// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__YnxCQJ+F","loader":"Loader_loader__n0-Jiz0u","loaderAnimation":"Loader_loaderAnimation__ZWp95wY6"};